var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pad" },
    [
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required|cnpj", name: _vm.nomeAba + "/CNPJ" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "CNPJ:", required: true }
                        }),
                        _c("el-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "##.###.###/####-##",
                              expression: "'##.###.###/####-##'"
                            }
                          ],
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "cnpj" },
                          model: {
                            value: _vm.pessoaJuridica.cnpj,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoaJuridica, "cnpj", $$v)
                            },
                            expression: "pessoaJuridica.cnpj"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 16 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name: _vm.nomeAba + "/Razão social"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Razão social:", required: true }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "razaoSocial", maxlength: "300" },
                          model: {
                            value: _vm.pessoaJuridica.razaoSocial,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoaJuridica, "razaoSocial", $$v)
                            },
                            expression: "pessoaJuridica.razaoSocial"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-input-telefone", {
                attrs: {
                  telefones: _vm.pessoa.telefones,
                  requiredTelefones: true,
                  nomeAba: _vm.nomeAba,
                  observer: _vm.observer
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 16 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required|email",
                  name: _vm.nomeAba + "/E-mail pessoa jurídica"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "E-mail:", required: true }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "email", maxlength: "100" },
                          model: {
                            value: _vm.pessoa.email,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoa, "email", $$v)
                            },
                            expression: "pessoa.email"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb89d3a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb89d3a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppPessoaJuridica.vue
// module id = null
// module chunks = 